// Окно разбора, открытое кнопкой бота второй раз, находит свою задачу среди
// задач за сутки: тот же набор кодов постов. Правило то же, что у сервера
// (`reusable_analysis` в backend/src/cf2/api/tools.py): упавшая задача и задача,
// где часть ссылок не разобралась, не подходят — их запускают заново.

export interface JobLike {
  id: string
  kind: string
  status: string
  codes?: string[] | null
  result?: unknown
}

function hasFailedLinks(result: unknown): boolean {
  if (!result || typeof result !== 'object' || !('failed' in result)) return false
  const failed = (result as { failed?: unknown }).failed
  return Array.isArray(failed) && failed.length > 0
}

/** Самая свежая подходящая задача (список — новые первыми) или null. */
export function findAnalysisJob<T extends JobLike>(jobs: readonly T[], codes: readonly string[]): T | null {
  if (codes.length === 0) return null
  const wanted = new Set(codes)
  for (const job of jobs) {
    if (job.kind !== 'analyze' || !job.codes) continue
    const have = new Set(job.codes)
    if (have.size !== wanted.size || [...wanted].some((c) => !have.has(c))) continue
    if (job.status === 'failed' || (job.status === 'done' && hasFailedLinks(job.result))) continue
    return job
  }
  return null
}
